import { Component } from '@theme/component';

const selectors = {
  PARALLAX_BANNER_BACKGROUND: '.js-parallax-banner-background',
  VIDEO_PLAYER_SELECTOR: 'video-player',
  HERO_SELECTOR: '.hero',
};

const classNames = {
  INVISIBLE: 'invisible',
};

const attributes = {
  TIMEOUT_PLAY: 200,
};

class ParallaxCustom extends Component {
  connectedCallback() {
    this.parallaxBannerBackground = /** @type {HTMLElement | null} */ (
      this.querySelector(selectors.PARALLAX_BANNER_BACKGROUND)
    );
    this.videoPlayer = this.querySelector(selectors.VIDEO_PLAYER_SELECTOR);
    this.hero = /** @type {HTMLElement | null} */ (this.querySelector(selectors.HERO_SELECTOR));

    if (!this.parallaxBannerBackground) {
      console.log('Parallax banner background element not found');

      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.parallaxBannerBackground?.classList.remove(classNames.INVISIBLE);
          } else {
            this.parallaxBannerBackground?.classList.add(classNames.INVISIBLE);
          }
        });
      },
      {
        rootMargin: '200px 0px',
        threshold: 0.1,
      },
    );

    this.observer.observe(this.hero || this);

    // Try to resume video playback when the tab becomes visible again
    // (browser may pause media or block autoplay)
    this.handleVisibilityChange = () => {
      if (!document.hidden && this.videoPlayer) {
        setTimeout(() => {
          try {
            const player = this.videoPlayer;
            const canPlay = player && 'play' in player && typeof player.play === 'function';
            let maybePromise = null;

            if (canPlay) {
              const playFn = /** @type {() => Promise<void> | void} */ (player.play);
              maybePromise = playFn.call(player);
            }

            if (maybePromise && typeof maybePromise.catch === 'function') {
              maybePromise.catch(() => {
                console.warn('Could not autoplay video');
              });
            }
          } catch (error) {
            console.error('Error playing video:', error);
          }
        }, attributes.TIMEOUT_PLAY);
      }
    };

    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }

    if (this.handleVisibilityChange) {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }
  }
}

if (!customElements.get('parallax-custom')) {
  customElements.define('parallax-custom', ParallaxCustom);
}
